import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseIsAIEnabledForContentQuery, {
	type useIsAIEnabledForContentQuery$data,
	type useIsAIEnabledForContentQuery$variables,
} from '../../hooks/__generated__/useIsAIEnabledForContentQuery.graphql.ts';

export function preloadUseIsAIEnabledForContentQuery(contentId: string) {
	return query<useIsAIEnabledForContentQuery$data, useIsAIEnabledForContentQuery$variables>({
		query: UseIsAIEnabledForContentQuery,
		variables: {
			contentId,
		},
	});
}
